<template>
	<div v-if="showModal" class="modal">
		<div class="modal-header">
			<div class="modal-title">
				<span>Attention!</span>
			</div>
			<div class="close" title="close">
				<ion-icon name="ios-close" @click="closeModal"></ion-icon>
			</div>
		</div>
		<div class="modal-body">
			<h1>
				Naij News is now
				<br />
				<span>Stack</span>
				<span>You can still access Stack through naijnews.co</span>
			</h1>
		</div>
		<div class="modal-footer">
			<p>Keep checking for more changes</p>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			showModal: true
		};
	},
	beforeMount() {
		const app = document.querySelector("#app");
		app.classList.add("blur-app");
		app.addEventListener("click", () => {
			if (this.showModal) {
				this.closeModal();
			}
		});
	},
	methods: {
		closeModal() {
			app.classList.remove("blur-app");
			this.showModal = false;
		}
	}
};
</script>

<style lang="css" src="../../styles/modalStyles.css" scoped></style>
<!--<style lang="scss" scoped>
     @import "../../styles/modalStyles.scss";
</style>-->
<style scoped>
.modal-body {
	display: grid;
	align-items: center;
	width: 100%;
	height: 80%;
}

.modal-body h1 {
	font-size: 25px;
	font-weight: 800;
}

.modal-body h1 span:first-of-type {
	font-size: 45px;
	color: #51c715;
	font-weight: 100;
}

.modal-body h1 span:last-of-type {
	font-size: 13px;
	font-family: inherit;
	color: #b7b7b7;
	font-weight: 100;
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/WelcomeModal.vue